import React from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Upload, Button } from '@elevio/elevio-styles/dist/components/hq';
import Input from '../input';
import Textarea from '../textarea';
import Rate from '../rate';
import Radio from '../radio';
import Checkbox from '../checkbox';
import Select from '../select';
import styles from './style.css';

@observer
export default class FieldRow extends React.Component {
  static propTypes = {
    addFilesTranslation: PropTypes.string,
    field: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      type: PropTypes.string.isRequired,
      dataType: PropTypes.string.isRequired,
      isEmail: PropTypes.bool.isRequired,
      required: PropTypes.bool,
      allowHalf: PropTypes.bool,
      response: PropTypes.oneOfType([
        PropTypes.string,
        mobxPropTypes.observableArray,
        PropTypes.number,
        PropTypes.shape({
          file: PropTypes.shape({
            name: PropTypes.string,
          }),
          fileList: mobxPropTypes.observableArray,
        }),
      ]),
      multiple: PropTypes.bool,
      isTextBlock: PropTypes.bool.isRequired,
      options: PropTypes.oneOfType([
        mobxPropTypes.observableArray,
        PropTypes.array,
      ]).isRequired,
    }),
    getUploadStore: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isValidUi: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  static defaultProps = {
    addFilesTranslation: '',
    field: {
      name: '',
      options: [],
      response: '',
      multiple: false,
      allowHalf: false,
      required: false,
    },
  };

  inputs = () => {
    const {
      isEmail,
      id,
      response,
      options,
      multiple,
      allowHalf,
    } = this.props.field;
    return {
      text: (
        <Input
          isEmail={isEmail}
          fieldId={id}
          value={response}
          onChange={e => this.props.onChange(e.target.value, id, isEmail)}
        />
      ),
      email: (
        <Input
          isEmail={isEmail}
          fieldId={id}
          value={response}
          onChange={e => this.props.onChange(e.target.value, id, isEmail)}
        />
      ),
      textarea: (
        <Textarea
          fieldId={id}
          value={response}
          onChange={e => this.props.onChange(e.target.value, id, isEmail)}
        />
      ),
      select: (
        <Select
          options={options}
          fieldId={id}
          mode={multiple ? 'multiple' : 'none'}
          response={response}
          onChange={e => this.props.onChange(e, id, isEmail)}
        />
      ),
      radio: (
        <Radio
          options={options}
          fieldId={id}
          response={response}
          onChange={e => this.props.onChange(e.target.value, id, isEmail)}
        />
      ),
      checkbox: (
        <Checkbox
          options={options}
          fieldId={id}
          response={response}
          onChange={e => this.props.onChange(e, id, isEmail)}
        />
      ),
      rate: (
        <Rate
          fieldId={id}
          allowHalf={allowHalf}
          response={response}
          onChange={e => this.props.onChange(e, id, isEmail)}
        />
      ),
      upload: uploadStore =>
        uploadStore && (
          <Upload
            customRequest={uploadStore.uploadFile}
            fileList={toJS(uploadStore.fileList)}
            onRemove={uploadStore.removeFile}
          >
            <Button>{this.props.addFilesTranslation}</Button>
          </Upload>
        ),
    };
  };

  render() {
    const { id, name, required, type, isTextBlock } = this.props.field;
    const uploadStore =
      type === 'upload' ? this.props.getUploadStore(id) : null;
    const input =
      type === 'upload'
        ? this.inputs()[type](uploadStore)
        : this.inputs()[type];
    if (type === 'article') {
      return <elevio-element data-type="article" data-id={name} />;
    }
    if (isTextBlock && type !== 'article') {
      return <div className={`${styles[type]}`}>{name}</div>;
    }
    const { isValidField, message } = this.props.isValidUi[id];
    return (
      <Form.Item
        key={id}
        label={name}
        validateStatus={isValidField ? '' : 'error'}
        required={required}
        help={isValidField ? '' : message}
      >
        <div className={styles.row}>{input}</div>
      </Form.Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/fieldrow/index.js